import React, { useEffect } from "react";
import * as yup from "yup";
import { connect } from "react-redux";
import { useChargeForm } from "../../hooks/useChargeForm";
import { checkoutInvoice } from "../../../../../store/checkoutInvoice";
import { useInvoice } from "../../hooks/invoice/useInvoice";
import { useInvoiceActions } from "../../hooks/useInvoiceActions";
import { composeAmountSchema } from "../../SalesCheckoutInvoice.schemas";
import PaymentFormModal from "./components/PaymentFormModal";
import ViewTipsModal from "../ViewTipsModal/ViewTipsModal";
import { tCommon, tSales } from "../../../../../i18n/useAppTranslation";
import { ModalCharge } from "../../shared/ModalCharge/ModalCharge";
import { img } from "../../../../../assets/img";

const ViewChargeGreenSky = ({ isTipsApplying }) => {
  const { invoice, amountToPay } = useInvoice();
  const { chargeGreenSky, paymentViewClose } = useInvoiceActions();

  const schema = yup.object({
    amount: composeAmountSchema({
      amountToPay: amountToPay,
      currency: invoice?.currency,
    }),
    note: yup.string(),
  });

  const { form, changeFormValue, hasError, errors, isValid, submit } =
    useChargeForm({
      schema,
      onSubmit: ({ amount, note }) => {
        chargeGreenSky.initiate({
          amount,
          note,
        });
      },
      initialValues: {
        amount: amountToPay || "",
        note: "",
      },
    });

  useEffect(() => {
    changeFormValue("amount", amountToPay);
  }, [amountToPay]);

  return (
    <ModalCharge
      isOpen
      onClose={paymentViewClose}
      title={tSales("checkoutInvoice.paymentOptions.greenSky")}
      imageSrc={img.greenSky}
      onCharge={submit}
      isCharging={chargeGreenSky.isLoading}
      chargeLabel={tCommon("label.charge")}
      amount={form.amount}
      isChargeDisabled={!isValid || isTipsApplying}
    >
      <ViewTipsModal amountToPay={amountToPay} />
      <PaymentFormModal
        form={form}
        errors={errors}
        hasError={hasError}
        changeFormValue={changeFormValue}
      />
    </ModalCharge>
  );
};

const mapStateToProps = (state) => ({
  isTipsApplying: checkoutInvoice.selectors.selectIsTipsApplying(state),
});

export default connect(mapStateToProps)(ViewChargeGreenSky);
